var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({ref:"btnItinerary",style:(_vm.style),attrs:{"disabled":_vm.$route.name === 'Itinerary',"icon":"","color":"primary","height":"50px","width":"50px"},on:{"click":_vm.goItinerary}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("far fa-route")])],1)]}}])},[_c('span',[_vm._v("Nouvel itinéraire")])])}
var staticRenderFns = []

export { render, staticRenderFns }